import { feedbacks } from "@/mocks/feed";
import SectionHeading from "./SectionHeading";

export default function About() {
  return (
    <section id="about" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-900 via-background-800 to-background-900"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/30"></div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <SectionHeading
              dark
              eyebrow="关于我们 · 关于前线"
              title="不靠二手转述，我们站在事件最前面"
              desc="吃瓜前线相信：一个热点最好的打开方式，是回到它发生的第一现场。我们花时间蹲守、核对、归档，把一手实拍与目击细节原原本本交到你面前。"
            />
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/80 md:text-base">
              从一条路透冒出到多方回应，再到尘埃落定，吃瓜前线负责把散落的碎片拼回完整事件链，标清已核实与待核实的信息。我们不做情绪化搬运，只做让瓜更清楚的那双眼睛。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {["一手实拍", "目击细节", "原发经过", "持续回刷", "理性吃瓜"].map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1.5 text-xs font-medium text-background-50 whitespace-nowrap"
                >
                  {t}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="mailto:report@guafront.cn"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill" aria-hidden="true"></i>
                加入爆料 · 提供现场素材
              </a>
              <a
                href="mailto:hello@guafront.cn"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/25 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
                联系我们
              </a>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid gap-4 sm:grid-cols-3">
              {feedbacks.map((fb, i) => (
                <figure key={fb.name} className={`rounded-2xl border border-background-50/15 bg-background-50/5 p-4 backdrop-blur-sm ${i === 1 ? "sm:translate-y-4" : ""}`}>
                  <i className="ri-double-quotes-l text-2xl text-accent-400" aria-hidden="true"></i>
                  <blockquote className="mt-2 text-sm leading-relaxed text-background-100/90">“{fb.text}”</blockquote>
                  <figcaption className="mt-3 flex items-center gap-2 text-xs text-background-100/70">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-50/15">
                      <i className="ri-user-fill" aria-hidden="true"></i>
                    </span>
                    {fb.name}
                  </figcaption>
                </figure>
              ))}
            </div>
            <p className="mt-4 text-xs leading-relaxed text-background-100/60">
              本站为网络公开热点信息的聚合整理平台，内容仅供参考；信息来源与核对状态已在各事件链中标注。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}